/**
 * Converts a variable to a number, or zero otherwise
 * @param {Any} x Tries to conver a given variable to a number. Returns 0 if invalid
 */
function _convertToInt(x) {
  const number = {
    number: x,
    string: parseInt(x, 10),
  }[typeof x];
  // Handles edge case where number is invalid
  if (!number || Number.isNaN(number)) return 0;
  return number;
}

/**
 * Given a time in seconds, return the time in minutes
 * @param {Number} timeSeconds is the time in seconds
 */
function secondsToMinutes(timeSeconds) {
  return Math.floor(_convertToInt(timeSeconds) / 60);
}

/**
 * Given a time in minutes, convert it to seconds
 * @param {Number} timeMinutes Converts time in minutes to seconds
 */
function minutesToSeconds(timeMinutes) {
  return _convertToInt(timeMinutes) * 60;
}

export {
  secondsToMinutes,
  minutesToSeconds,
};
